import { PageHeader } from "@/components/PageHeader";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { ComposeTab } from "./ComposeTab";
import { DraftsTab } from "./DraftsTab";
import { SendHistoryTab } from "./SendHistoryTab";
import type { ProductEmailSend } from "./types";

type TabId = "compose" | "history" | "drafts";

const TABS: { id: TabId; label: string }[] = [
  { id: "compose", label: "Compose" },
  { id: "history", label: "Send History" },
  { id: "drafts", label: "Drafts" },
];

export default function ProductEmailPage() {
  const [activeTab, setActiveTab] = useState<TabId>("compose");
  const [loadedDraft, setLoadedDraft] = useState<ProductEmailSend | null>(
    null
  );

  const handleLoadDraft = (draft: ProductEmailSend) => {
    setLoadedDraft(draft);
    setActiveTab("compose");
  };

  const handleDraftCleared = () => {
    setLoadedDraft(null);
  };

  return (
    <div className="px-4 py-0">
      <PageHeader
        title="Product Emails"
        subtitle="Compose and send emails to your users"
      />

      {/* Tab navigation */}
      <div className="mb-6 border-b border-zinc-200 dark:border-zinc-700">
        <nav className="-mb-px flex gap-6">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={cn(
                "border-b-2 pb-3 text-sm font-medium transition-colors",
                activeTab === tab.id
                  ? "border-blue-500 text-blue-600 dark:text-blue-400"
                  : "border-transparent text-zinc-500 hover:border-zinc-300 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-300"
              )}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab content */}
      {activeTab === "compose" && (
        <ComposeTab
          initialDraft={loadedDraft}
          onDraftCleared={handleDraftCleared}
        />
      )}
      {activeTab === "history" && <SendHistoryTab />}
      {activeTab === "drafts" && <DraftsTab onLoadDraft={handleLoadDraft} />}
    </div>
  );
}
